import React, { JSX, PureComponent } from "react"
import { FormCadProps, FormCad, FormButtonActionsProps } from "../viewCadastro/formCad"
import { Box, Chip, Stack } from "@mui/material";
import { getKeyValue, isEmpty } from "../../services/utils";

interface FieldFiltedShow {
    name: string
    label:string
    handleOnDelete?: () => void
    handleOnClick?: () => void
}
export interface OwnPropsFiltroView {
    form: FormCadProps
    showFormFiltro: boolean
    listFieldShow: FieldFiltedShow[]
}


export default class FiltroView extends PureComponent<OwnPropsFiltroView> {


    render(): React.ReactNode {
        const { form, showFormFiltro, listFieldShow, } = this.props;
        const valuesFiltered = (): Array<JSX.Element> => {
            let chip: JSX.Element = <div style={{ display: 'none' }}></div>
            let chips: Array<JSX.Element> = []
            listFieldShow.map((field, idx) => {
                const value = getKeyValue(form.row, field.name);
                if (!isEmpty(value)) {
                    chip = <Chip
                        key={idx}
                        label={field.label+": "+ value}
                        variant="outlined"
                        color="primary"
                        onDelete={field.handleOnDelete}
                        onClick={field.handleOnClick}
                    />
                    chips.push(chip);
                }
            })
            return chips
        }


        if (showFormFiltro)
            return (
                <FormCad
                    contentForm={form.contentForm}
                    row={form.row}
                    handleMutator={form.handleMutator}
                    handleOnSubmit={form.handleOnSubmit}
                    handleCancel={form.handleCancel}
                    buttonActions={form.buttonActions}
                    ContentBox={form.ContentBox}
                    formValidation={form.formValidation}
                    mutators={form.mutators}
                />
            )
        else
            return (
                <Stack direction={"row"} spacing={1} justifyContent={"flex-start"} flexWrap={"wrap"}>
                    {valuesFiltered().map(myChip => (
                        myChip
                    ))}
                </Stack>
            )
    }
}